module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "userDetailsContainer": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("General Information")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Regions")]), _vm._v(" "), _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Linked Users")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-left": "15px !important",
      "padding-top": "2% !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h3', [_vm._v("General Info")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.contactHeaders,
      "items": _vm.currentUser,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(_vm.fncCheckNull(props.item.alt_contactno)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(props.item.vat_no))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s(props.item.address))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(props.item.pmoc))])]
      }
    }])
  }), _vm._v(" "), _c('h3', {
    staticClass: "headerSplit"
  }, [_vm._v("Limits")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.limitHeaders,
      "items": _vm.currentUser,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s(props.item.discount_max) + "%")]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s(props.item.discount_def) + "%")]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s(props.item.contri_min) + "%")]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s(props.item.inc_max))])]
      }
    }])
  }), _vm._v(" "), _c('h3', {
    staticClass: "headerSplit"
  }, [_vm._v("Additional Info")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.infoHeaders,
      "items": _vm.currentUser,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.active))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(_vm.fncGetUserType(props.item.type)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.created))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.modified))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(_vm.fncTrim(props.item.pricelists)))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "2% !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('br')], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "search": _vm.search,
      "headers": _vm.regionHeaders,
      "items": _vm.currentRegions,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "2% !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("User Type:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.linkType,
      "label": "User Type",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.linkTypeSingle),
      callback: function($$v) {
        _vm.linkTypeSingle = $$v
      },
      expression: "linkTypeSingle"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.linkTypeSingle.id == 'rep') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.searchReps),
      callback: function($$v) {
        _vm.searchReps = $$v
      },
      expression: "searchReps"
    }
  }) : _vm._e(), _c('br')], 1), _vm._v(" "), (_vm.linkTypeSingle.id == 'rep') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "search": _vm.searchReps,
      "headers": _vm.regionHeaders,
      "items": _vm.userReps,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))])]
      }
    }], null, false, 4206739215)
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.linkTypeSingle.id == 'company') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.searchCompanies),
      callback: function($$v) {
        _vm.searchCompanies = $$v
      },
      expression: "searchCompanies"
    }
  }) : _vm._e(), _c('br')], 1), _vm._v(" "), (_vm.linkTypeSingle.id == 'company') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "search": _vm.searchCompanies,
      "headers": _vm.regionHeaders,
      "items": _vm.userCompanies,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))])]
      }
    }], null, false, 4206739215)
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.linkTypeSingle.id == 'customer') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.searchCustomers),
      callback: function($$v) {
        _vm.searchCustomers = $$v
      },
      expression: "searchCustomers"
    }
  }) : _vm._e(), _c('br')], 1), _vm._v(" "), (_vm.linkTypeSingle.id == 'customer') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "search": _vm.searchCustomers,
      "headers": _vm.regionHeaders,
      "items": _vm.userCustomers,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))])]
      }
    }], null, false, 4206739215)
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requiredMessage",
    attrs: {
      "lg12": ""
    }
  }, [_c('small', [_c('strong', [_vm._v(" ")])])])], 1)], 1)], 1)
},staticRenderFns: []}